import { Component } from '@angular/core';

@Component({
  selector: 'app-wiper-loading',
  templateUrl: './wiper-loading.component.html',
  styleUrl: './wiper-loading.component.scss',
})
export class WiperLoadingComponent {}
